import { render } from "./BaseTableIntroductions.vue?vue&type=template&id=1781720b&scoped=true"
import script from "./BaseTableIntroductions.vue?vue&type=script&lang=js"
export * from "./BaseTableIntroductions.vue?vue&type=script&lang=js"

import "./BaseTableIntroductions.vue?vue&type=style&index=0&id=1781720b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1781720b"]])

export default __exports__